import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { TdLoadingService, TdMediaService } from '@covalent/core';

import { ResumenPacienteService, LoginService, HojaDeConsultaService, NotasService } from '../../../services/';
import { Nota } from '../../../models';

@Component({
  selector: 'qs-resumenpaciente',
  templateUrl: './resumenpaciente.component.html',
  styleUrls: ['./resumenpaciente.component.scss'],
  viewProviders: [ResumenPacienteService, HojaDeConsultaService, NotasService],
})
export class ResumenpacienteComponent implements AfterViewInit, OnInit {

  private idPaciente: string;
  private numeroVisita: string;
  private resumenPaciente: any;
  private _toggleConstantes: boolean = true;
  private _toggleProblemas: boolean = true;
  private _toggleAntecedentes: boolean = true;
  private _toggleAlergias: boolean = true;
  private _toggleHabitos: boolean = true;
  private _toggleFarmacos: boolean = true;
  public notas: Nota[];

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _resumenPacienteService: ResumenPacienteService,
    private _hojaDeConsultaService: HojaDeConsultaService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _notasService: NotasService) { }

  ngOnInit(): void {
    this._hojaDeConsultaService.agregarDatosAdministrativos(
                    this._loginService.consulta.numeroExpediente,
                ).subscribe((respuesta: any) => {
                        this._loginService.consulta.sexo = respuesta.respuesta.sexo;
                        this._loginService.consulta.fechaNacimiento = respuesta.respuesta.fechaNacimiento;
                        this._loginService.consulta.dni = respuesta.respuesta.dni;
        // tslint:disable-next-line: no-empty
        }, (error: Error) => {
    });
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Resumen del paciente');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.numeroVisita = this._loginService.consulta.visita;
    this._loadingService.register('resumen.load');
    this._notasService.obtenerNotas(this.idPaciente, this._loginService.profesional.Dni, false).subscribe((res: any) => {
      this.notas = res.respuesta.notas || [];
      // tslint:disable-next-line: no-shadowed-variable
      this._resumenPacienteService.obtenerResumenPaciente(this.idPaciente, this.numeroVisita).subscribe((res: any) => {
        this.resumenPaciente = res.resumen;
        this._loadingService.resolve('resumen.load');
      }, (error: Error) => {
        this._loadingService.resolve('resumen.load');
      });
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo notas.', 'OK', 6000);
    });
    this._changeDetectorRef.detectChanges();
  }

  toggleConstantes(): void {
    this._toggleConstantes = !this._toggleConstantes;
  }
  toggleProblemas(): void {
    this._toggleProblemas = !this._toggleProblemas;
  }
  toggleAntecedentes(): void {
    this._toggleAntecedentes = !this._toggleAntecedentes;
  }
  toggleAlergias(): void {
    this._toggleAlergias = !this._toggleAlergias;
  }
  toggleHabitos(): void {
    this._toggleHabitos = !this._toggleHabitos;
  }
  toggleFarmacos(): void {
    this._toggleFarmacos = !this._toggleFarmacos;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/resumenpaciente/resumenpaciente.component.ts